import { render } from "./home-featured-sec.vue?vue&type=template&id=bd3f3bc6&scoped=true"
import script from "./home-featured-sec.vue?vue&type=script&lang=js"
export * from "./home-featured-sec.vue?vue&type=script&lang=js"

import "./home-featured-sec.vue?vue&type=style&index=0&id=bd3f3bc6&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3f3bc6"]])

export default __exports__